import React from 'react';

import { isNudeDomain } from '../../utils/helpers';

import NudeNewsPrivacyPolicy from './NudeNewsPrivacyPolicy';


const PrivacyPolicy = () => isNudeDomain ? (
  <NudeNewsPrivacyPolicy />
) : (
  <div className="content">
    <div className="container">
      <h1 className="h3">Naked News Privacy Policy</h1>
      <small>Effective Date: February 1, 2019</small>
      {/* <p>
                    To view our previous Privacy Policy,{' '}
                    <a href="/privacy_policy?archive=20130904">
                        click here
                    </a>
                    .
                </p>*/}
      <ol>
        <li>
          <a href="/privacy_policy#s1">Introduction</a>
        </li>
        <li>
          <a href="/privacy_policy#s2">
            Information we collect
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s3">
            How we use the information we collect
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s4">
            How we share the information we collect
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s5">
            Cookies and other tracking technologies
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s6">
            Information collected by third parties
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s7">Email opt-out</a>
        </li>
        <li>
          <a href="/privacy_policy#s8">
            Credit card processing
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s9">Security</a>
        </li>
        <li>
          <a href="/privacy_policy#s10">
            Children and COPPA compliance
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s11">
            Business transitions
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s12">
            California users consumer rights
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s13">
            Users located outside of the United States
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s14">
            EU users rights under the GDPR
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s15">Data retention</a>
        </li>
        <li>
          <a href="/privacy_policy#s16">
            Cooperation with law enforcement; fraud
            protection
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s17">
            Changes to this Privacy Policy
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s18">Who we are</a>
        </li>
      </ol>
      <a name="s1" />
      <p className="h4">1. Introduction</p>
      <p>
        Please read the following policy to understand how
        your personal information will be treated as you
        make full use of our Website. When we talk about our
        Website or our Service, we are referring to this
        website, any corresponding mobile application and
        any services provided by us through such website
        and/or application. When we talk about "we", ''our''
        or ''us'' in this policy, we are referring to
        Egalaxy Multimedia Inc, the company that provides
        the Website and Service. If you have any questions,
        concerns or complaints related to this Privacy
        Policy or our processing of your personal
        information, please email us here:{' '}
        <a href="mailto:privacy@nakednews.com">
          privacy@nakednews.com
        </a>
        . This email address is monitored on a regular basis
        and we aim to respond to your query as soon as
        possible.
      </p>
      <p>The Privacy Policy has three main purposes:</p>
      <ol>
        <li>
          Explain the way we use information that you
          share with us in order give you a great
          experience with our Website;
        </li>
        <li>
          Ensure that you understand what information we
          collect with your permission, what we do with it
          and with whom we share it; and
        </li>
        <li>Explain your rights under applicable law.</li>
      </ol>
      <p>
        All the information we collect is related to
        providing our Website or Service. By agreeing to our
        Privacy Policy, you give us the right to collect
        your information as detailed in this Privacy Policy
        and use it for the purposes described in this
        Privacy Policy. IF YOU DON'T AGREE WITH THE TERMS OF
        THIS PRIVACY POLICY, THEN PLEASE DON'T USE THE
        WEBSITE OR SERVICE.
      </p>
      <a name="s2" />
      <p className="h4">2. Information we collect</p>
      <p>
        The information we collect can be divided into the
        following broad categories:
      </p>
      <ul>
        <li>
          Technical Data includes internet protocol (IP)
          address, your login data, device type, device
          version, browser type and version, browser
          plug-ins types, time zone setting and location,
          traffic data, search criteria, weblogs and other
          communications data, operating system and
          platform and other technology on the devices you
          use to access the Website.
        </li>
        <li>
          Usage Data includes information about how you
          use our Website or Service, such as the
          particular pages you interact with, how often
          you visit, how long you're on the Website,
          surveys, the service you're looking, your
          preference ratings, at and the emails you
          interact with.
        </li>
        <li>
          Financial Data includes payment card details you
          provide, including expiration date. It also
          includes details about your payment history and
          services or products you have purchased from us.
        </li>
        <li>
          Identity Data includes email address, username
          and password, and for subscribers, full name,
          billing address.
        </li>
      </ul>
      <p>
        More specifically, we may collect and store the
        following information relating to you:
      </p>
      <a name="s2.1" />
      <p className="h5">2.1 Anonymous data</p>
      <p>
        When you visit our Website, we collect some basic
        information that does not identify individual users.
        This includes which pages are visited and any
        feedback from our visitors. We then aggregate this
        information with other pieces of information to
        improve our Website and make your experience on the
        Website as valuable and efficient as possible. We
        may also collect and accumulate anonymous data that
        will help us understand and analyze the online
        experience of our Website users. For instance, we
        may accumulate visitor data relating to referring
        domain names, the type of browsers used, operating
        system software, screen resolutions, color
        capabilities, browser plug-ins, language settings,
        cookie preferences, search engine keywords and
        JavaScript enablement.
      </p>
      <a name="s2.2" />
      <p className="h5">2.2 Direct Interactions</p>
      <p>
        We collect information from you when you voluntarily
        submit information directly to us or via our
        Website. For members, this refers to personal data
        you provide when, for example, you create an
        account, complete a profile, or by corresponding
        with us via phone, email or live chat. This personal
        information may include name, age, address, phone
        and email, as necessary to set up your account. If
        you connect to the Website using credentials from a
        third-party application (e.g., Facebook), you
        authorize us to collect your authentication
        information, such as your username and encrypted
        access credentials. We may also collect other
        information available on or through your third-party
        application account, including, for example, your
        name, profile picture, country, hometown, email
        address, date of birth, gender, friends' names and
        profile pictures, and networks.
      </p>
      <p>
        You may decide to provide us with another person s
        contact information so that person may be invited to
        join our Service or so that we may facilitate your
        communication with other people through the Service
        (such as when you upload an address book or a
        contact list). You may also provide us with another
        person's contact information for purposes of
        delivering information through social networking
        applications. We store the information that you
        provide so that the respondents may be added to your
        network, and also to send reminders of the
        invitations. All invitees are provided with the
        option not to receive further invitations from us.
      </p>
      <p>
        In addition to the information we may collect upon
        your initial registration, we may ask you for
        personal information at other times. We will not
        share that information in a manner that identifies
        you as an individual with any other entity unless we
        have your permission.
      </p>
      <a name="s2.3" />
      <p className="h5">
        2.3 Information submitted by you for inclusion on
        the Website
      </p>
      <p>
        Please remember that if you post any of your
        personal information in public areas of the Website,
        such as in online forums or chat rooms, such
        information may be collected and used by others over
        whom we have no control. We are not responsible for
        the use made by third parties of information you
        post or otherwise make available in public areas of
        the Website. You should take care to not use
        personal information in your screen name or other
        information that might be publicly available to
        other users.
      </p>
      <a name="s2.4" />
      <p className="h5">2.4 Tracking technologies</p>
      <p>
        We use "cookies" and similar tracking technologies
        (as described in{' '}
        <a href="/privacy_policy#s5">Section 5</a> below and
        in our <a href="/cookie-policy">Cookie Policy</a>)
        to track your activities on our Website, and may
        also receive data about you if you visit other
        websites employing our cookies. When we send you
        emails that include a link to the Website, that link
        may contain an alphanumeric identifier that allows
        us to identify the person to whom we sent the
        message so that we can personalize our content for
        that individual.
      </p>
      <a name="s2.5" />
      <p className="h5">
        2.5 Automated technologies or interactions
      </p>
      <p>
        As you interact with our Website, we may
        automatically collect technical and usage data about
        your device, browsing actions and patterns. For
        example, we collect information which may include
        your IP address, browser type, your location,
        language preferences, device information and access
        times. While an IP address does not identify an
        individual by name, it may, with the cooperation of
        the ISP, be used to locate and identify an
        individual. Your IP address can reveal what
        geographic area you are connecting from, or which
        ISP you are using. Finally, other websites you visit
        have IP addresses, and we may collect the IP
        addresses of those websites and their pages. We also
        collect IP addresses for system administration and
        to report aggregate information to any sponsors. We
        may also receive information from our web logs,
        which automatically record anything a web server
        sees, which may include email addresses you enter
        into a form or pages viewed by a user at a
        particular IP address. We collect this personal data
        by using cookies, pixel tags and other similar
        tracking technologies. The sole purpose of passively
        collecting your information is to improve your
        experience when using our Website.
      </p>
      <a name="s2.6" />
      <p className="h5">2.6 Promotions &amp; surveys</p>
      <p>
        From time to time, we may offer you the opportunity
        to participate in promotions such as sweepstakes,
        contests, offers, and/or surveys ("Special
        Promotions") through the Service. A Special
        Promotion may be governed by a privacy policy and/or
        terms and conditions that are additional to, or
        separate from, this Privacy Policy and our{' '}
        <a href="/terms_of_service">Terms of Use</a>. If the
        provisions of the Special Promotions privacy policy
        or terms and conditions conflict with this Privacy
        Policy or our{' '}
        <a href="/terms_of_service">Terms of Use</a>, those
        additional or separate provisions shall prevail. If
        you participate in a Special Promotion, we may ask
        you for certain information in addition to what is
        stated in this Privacy Policy, including personal
        information. That additional information may be
        combined with other account information and may be
        used and shared as described in this Privacy Policy
        or in the Special Promotion.
      </p>
      <a name="s2.7" />
      <p className="h5">
        2.7 Information received from our service providers
        and partners
      </p>
      <p>
        We may also receive information about you from our
        service providers and partners, which we use to
        personalize our Service, to measure ad quality and
        responses to ads, to display ads that are more
        likely to be relevant to you, and to offer you
        opportunities to purchase products or services that
        we believe may be of interest to you.
      </p>
      <a name="s3" />
      <p className="h4">
        3. How we use the information we collect
      </p>
      <p>
        We have set out below, in a table format, a
        description of all the ways we process your personal
        data, and the legal basis we rely on to do so.
      </p>
      <table className="table-striped table-condensed">
        <thead>
          <tr>
            <th>Purpose/Activity</th>
            <th width="300">Type of Data</th>
            <th width="200">Legal Basis</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>To allow you to visit the Website</td>
            <td>Technical Data , Usage Data</td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>To allow you to create an account</td>
            <td>Identity Data, Usage Data</td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To register you as a paid member and
              process renewal of your membership
            </td>
            <td>Financial Data , Identity Data</td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To manage our relationship with you. For
              example general enquiries such as how
              the Website works, complaints and
              payment queries
            </td>
            <td>
              Any data you choose to share with us or
              request us to view
            </td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To administer and protect the Website
              (including troubleshooting, fraud
              prevention, spam prevention, security
              incident prevention and correction, data
              analysis, testing, system maintenance,
              support, reporting and hosting of data),
              operate the Website (including notifying
              you of any changes), optimize your user
              experience, and send you service and
              support messages such as updates,
              patches and security alerts
            </td>
            <td>
              Financial Data , Identity Data ,
              Technical Data , Usage Data
            </td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To send you promotional messages,
              marketing, advertising and other such
              information we think may be of interest
              to you, either directly or through one
              of our partners; you may opt out from
              receiving certain messages, as described
              in{' '}
              <a href="/privacy_policy#s7">
                Section 7
              </a>
            </td>
            <td>
              Financial Data , Identity Data ,
              Technical Data , Usage Data
            </td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To enable you to partake in a prize
              draw, competition, referral scheme,
              rewards program, promotional activities,
              events, complete a survey or invite you
              to participate in Website testing
            </td>
            <td>
              Financial Data Identity Data Technical
              Data
            </td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To analyze your use of the Website and
              deliver relevant website content and
              third-party advertisements, for example
              by providing customized, personalized,
              or localized content, recommendations,
              features, and advertising.
            </td>
            <td>Usage Data</td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To enable third parties to advertise
              products or services in which you may be
              interested, including via emails
            </td>
            <td>
              Identity Data, Usage Data, Technical
              Data
            </td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To enforce this Privacy Policy,
              our&nbsp;
              <a href="/terms_of_service">
                Terms of Use
              </a>
              , and any other terms that you have
              agreed to, including to protect the
              rights, property, or safety of our
              users, or any other person, or the
              copyright-protected content of the
              Website
            </td>
            <td>
              Identity Data , Usage Data, Technical
              Data
            </td>
            <td>
              For purposes of legitimate interests
            </td>
          </tr>
          <tr>
            <td>
              To maintain and retain records in
              connection with actual and potential
              legal claims and regulatory
              investigations; and for governance &amp;
              compliance purposes
            </td>
            <td>
              Financial Data , Identity Data , Usage
              Data, Technical Data
            </td>
            <td>
              Necessary for the compliance with a
              legal obligation to which we are subject
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        We will only use your personal data for the purposes
        for which we collected it, unless we reasonably
        consider that we need to use it for another reason,
        and that reason is compatible with the original
        purpose.
      </p>
      <p>
        Please note that we may process your personal data
        without your knowledge or consent, in compliance
        with the above rules, where this is required or
        permitted by law.
      </p>
      <a name="s4" />
      <p className="h4">
        4. How we share the information we collect
      </p>
      <p>
        This section describes how the information collected
        or generated through your use of the Website may be
        shared by us with third parties.
      </p>
      <a name="s4.1" />
      <p className="h5">4.1 Marketing and advertising</p>
      <p>
        We share information with advertising partners in
        order to send you promotional communications about
        our Website or to show you more tailored content,
        including relevant advertising for third-party
        products and services that may be of interest to
        you, and to understand how users interact with
        advertisements. We also share personally
        identifiable information with third-party
        advertisers to enable them to provide you with
        opportunities to learn of products or services in
        which you may be interested.
      </p>
      <p>
        We may also share aggregate user information in a
        non-personally identifiable manner with advertisers
        and other third parties in order to present to users
        more targeted advertising, products and services.
      </p>
      <a name="s4.2" />
      <p className="h5">4.2 Service providers</p>
      <p>
        We may from time to time share your information with
        third-party service providers to perform functions
        and process user data and help provide our Website
        or Service, consistent with this Privacy Policy. For
        example, we work with analytics providers to help us
        understand the use of our Website. Where a third
        party processes user data on our behalf, it is
        subject to security and confidentiality obligations
        consistent with this Privacy Policy and applicable
        law; we only permit them to process your personal
        data for specified purposes and in accordance with
        our instructions. Where a third party processes user
        data on its own behalf, its processing is subject to
        its own Privacy Policy and applicable law.
      </p>
      <p>
        To provide you with the best experience on our
        Website, we use third parties who automatically
        process your Usage Data on our behalf. Where
        possible, we will make sure this data is anonymized.
      </p>
      <p>
        In order to see the third party service providers we use to better serve you,{' '}
        <a href="/privacy_policy/3rd-parties">click here</a>{' '}
        to view these third party data processors and billing processors to see how they process your personal data.
      </p>
      <a name="s4.3" />
      <p className="h5">4.3 Affiliate networks</p>
      <p>
        If you access our Website through an offer that you
        received or purchased from a third party, we may
        also share information with that third party about
        your use of the Website, such as whether and to what
        extent you have used the offer, activated an
        account, or actively used our Service.
      </p>
      <a name="s4.4" />
      <p className="h5">4.4 Promotions and surveys</p>
      <p>
        When one or more of our business partners co-sponsor
        a service, promotion, contest/sweepstakes, or
        survey, we may share some or all of the information
        collected in connection with such service,
        promotion, contest/sweepstakes, or survey with the
        co-sponsor(s). If we intend to share such
        information, you will be notified prior to the
        collection of that information. If you do not want
        your information to be shared, you will be able to
        choose not to allow the transfer by not using or
        signing up for that particular service, promotion,
        contest/sweepstakes, or survey.
      </p>
      <a name="s5" />
      <p className="h4">
        5. Cookies and other tracking technologies
      </p>
      <p>
        A cookie is a small text file that is placed on your
        computer, mobile phone, or other device when you
        visit a website. The cookie will help website
        providers to recognize your device the next time you
        visit their website. There are other similar
        technologies such as pixel tags (transparent graphic
        images placed on a web page or in an email, which
        indicate that a page or email has been viewed), web
        bugs (similar to pixel tags), and web storage, which
        are used in desktop software or mobile devices.
      </p>
      <p>
        There are also technologies such as mobile device
        identifiers and SDK integrations to help companies
        recognize your device when you return to an app or
        otherwise use a service.
      </p>
      <p>
        Our policy regarding cookies can be{' '}
        <a href="/cookie-policy">found here</a>.
      </p>
      <a name="s6" />
      <p className="h4">
        6. Information collected by third parties
      </p>
      <p>
        Some entities that have links on our Website, such
        as advertisers, may collect personally identifying
        information about you when you access or utilize
        those links. We do not control the collection or use
        of such information, and the practices of those
        entities are not covered by this Privacy Policy. For
        instance, if you click on an advertisement on our
        Website, you may be taken away to an entirely
        different site. Links can be from advertisers,
        content providers and/or partners who may use our
        logo and/or style as a result of a co-branding
        agreement yet they may still not follow the same
        policies as this Privacy Policy with respect to
        collection of your personal information. In
        addition, our Website includes social media
        features, such as the Facebook Like button. These
        features may collect your IP address, which page you
        are visiting on our Website, and may set a cookie to
        enable the feature to function properly. Social
        media features and related widgets are either hosted
        by a third party or hosted directly on our Website.
        Your interactions with these features are governed
        by the privacy policy of the company providing them.
      </p>
      <p>
        Please read these third parties privacy policies to
        find out how they collect and process your personal
        information.
      </p>
      <a name="s7" />
      <p className="h4">7. Email Opt-out</p>
      <p>
        Users who no longer wish to receive our email
        updates or other notifications may opt out of
        receiving these communications by following the
        instructions contained in the applicable email or by
        logging in and changing their account settings.
        Please know that such a decision will not stop
        advertising or content that is generated prior to
        the time when we can accomplish the removal of your
        information.
      </p>
      <a name="s8" />
      <p className="h4">8. Credit Card Processing</p>
      <p>
        Credit card transactions are handled by a
        third-party processor that receives credit card
        numbers and other personally identifying information
        only to verify credit card accounts and process
        transactions.
      </p>
      <p>
        Credit card security is an important aspect of the
        online experience. We use encryption technology to
        keep your credit card information safe.
      </p>
      <p>
        BY ACCEPTING THE PRIVACY POLICY, YOU EXPRESSLY
        AUTHORISE US TO USE AND SHARE WITH CERTAIN TRUSTED
        BUSINESS PARTNERS AND SERVICE PROVIDERS, WHICH MAY
        BE LOCATED OUTSIDE OF THE COUNTRY OF YOUR RESIDENCE
        (INCLUDING COUNTRIES WHICH DO NOT PROVIDE THE SAME
        LEVEL OF PROTECTION FOR THE PROCESSING OF PERSONAL
        DATA AS THE COUNTRY OF YOUR RESIDENCE), THE
        INFORMATION PROVIDED BY YOU TO US, EVEN IF SUCH
        INFORMATION IS COVERED BY LOCAL BANKING SECRECY
        LAWS. YOU ACKNOWLEDGE AND AGREE TO THE IMPORTANCE OF
        SHARING SUCH INFORMATION FOR THE PROCESSING OF YOUR
        PURCHASE(S) AND ALSO AGREE THAT, BY ACCEPTING THIS
        PRIVACY POLICY, WHERE APPLICABLE AND TO THE EXTENT
        PERMITTED BY APPLICABLE LAW, YOU EXPRESSLY WAIVE
        YOUR RIGHTS UNDER SUCH BANK SECRECY LAWS WITH REGARD
        TO US AND ANY TRUSTED BUSINESS PARTNERS AND SERVICE
        PROVIDERS, WHICH MAY BE LOCATED OUTSIDE YOUR COUNTRY
        OF RESIDENCE. THIS CONSENT IS GIVEN FOR THE DURATION
        OF YOUR RELATIONSHIP WITH US.
      </p>
      <a name="s9" />
      <p className="h4">9. Security</p>
      <p>
        We have put in place appropriate security measures
        to prevent your personal data from being
        accidentally lost, altered or disclosed, used or
        accessed in an unauthorized way. In addition, we
        limit access to your personal data to those
        employees, agents, contractors and other third
        parties who have a business need to know it. They
        will only process your personal data on our
        instructions and they are subject to a duty of
        confidentiality. However, the transmission of data
        via the internet is not completely secure and we
        cannot guarantee that unauthorized parties will not
        be able to defeat those measures: unauthorized entry
        or use, hardware or software failure, and other
        factors may compromise the security of our user
        information at any time.
      </p>
      <p>
        We have put in place procedures to deal with any
        suspected personal data breach and will notify you
        and any applicable regulator of a breach where we
        are legally required to do so.
      </p>
      <a name="s10" />
      <p className="h4">10. Children and COPPA compliance</p>
      <p>
        We do not knowingly collect data relating to anyone under the age of 18. We have designed this privacy policy in order to comply with the Childrens Online Privacy Protection Act ("COPPA"). We will never knowingly collect any personal information about children under the age of 18. If we obtain actual knowledge that we have collected personal information about a child under the age of 18, that information will be immediately deleted from our database. Because we do not collect such information, we have no such information to use or to disclose to third parties. If a parent believes that his or her child has submitted personal information to us, he or she can contact us via e-mail or postal mail as listed below. We will promptly delete the information upon learning that it relates to a child under the age of 18. Please note that it is possible some of this information may remain archived in web logs and back-up archives after we delete the information from our active database.
      </p>
      <p>

        We believe that parents should supervise their children’s online activities and consider using parental control tools available from online services and software manufacturers that help provide a kid-friendly online environment. These tools can also prevent children from otherwise disclosing online their name, address and other personal information without parental permission.
      </p>
      <a name="s11" />
      <p className="h4">11. Business transitions</p>
      <p>
        In the event we go through a business transition,
        such as a merger, acquisition by another company, or
        sale of a portion of our assets, users personal
        information will, in most instances, be part of the
        assets transferred. In such instance, the new owners
        may use your personal data in the same way as set
        out in this Privacy Policy.
      </p>
      <a name="s12" />
      <p className="h4">
        12. California user consumer rights
      </p>
      <p>
        In accordance with California Civil Code Sec.
        1789.3, California resident users are entitled to
        know that they may file grievances and complaints
        with California Department of Consumer Affairs, 400
        R Street, STE1080, Sacramento, CA 95814; or by phone
        at 916-445-1254 or 800-952-5210; or by email to
        dca@dca.ca.gov. California Civil Code Section
        1798.83 also permits users who are California
        residents to request and obtain from us once a year,
        free of charge, a list of the third parties to whom
        we disclosed their personal data (if any) for direct
        marketing purposes in the preceding calendar year
        and the categories of data disclosed to those third
        parties. To make any sort of access request, please write to the following address: Egalaxy Multimedia Inc, Attn: M. Thibodeau, Privacy Rights, 2133 Danforth Avenue,  Suite 195, Toronto ON, M4C 1K2, Canada
      </p>
      <a name="s13" />
      <p className="h4">
        13. Users located outside of the United States
      </p>
      <p>
        We make an effort to protect the personal
        information of all users of our Website. If you are
        unsure whether this privacy policy is in conflict
        with the rules applicable where you are located, you
        should not submit your personal information. IN
        ADDITION, IF YOU ARE LOCATED WITHIN THE EUROPEAN
        UNION, YOU SHOULD NOTE THAT YOUR INFORMATION WILL BE
        TRANSFERRED TO THE UNITED STATES, THE LAWS OF WHICH
        MAY BE DEEMED BY THE EUROPEAN UNION TO HAVE
        INADEQUATE DATA PROTECTION. Users of our Website
        located in countries outside of the United States
        who submit personal information do thereby consent
        to the transfer of that information to and/or
        storage of the information in the United States.
      </p>
      <a name="s14" />
      <p className="h4">14. EU users rights under the GDPR</p>
      <p>
        If you are located in the European Union, or if the
        EU s General Data Protection Regulation ("GDPR")
        otherwise applies to your data as processed by us,
        you have the right to:
      </p>
      <ol>
        <li>
          request access to your personal data. This
          enables you to receive a copy of the personal
          data we hold about you and our full list of
          third parties who process your data or to whom
          we disclosed your data for direct marketing
          purposes, and to check that we are lawfully
          processing your data.
        </li>
        <li>
          request confirmation as to whether or not your
          personal data is being processed.
        </li>
        <li>
          request the correction of your personal data
          that you consider to be inaccurate. This enables
          you to have any incomplete or inaccurate data we
          hold about you corrected. However, we may need
          to verify your identity and the accuracy of the
          new data you provide to us.
        </li>
        <li>
          request erasure of your personal data. This
          enables you to ask us to delete or remove
          personal data, for example: i) where there is no
          good reason for us continuing to process it; ii)
          where you have successfully exercised your right
          to object to processing (see below); iii) where
          we may have processed your information
          unlawfully; iv) where we are required to erase
          your personal data to comply with local law.
          Note, however, that we may not always be able to
          comply with your request of erasure for specific
          legal reasons and our need to keep appropriate
          archives for our business operations. These
          reasons will be notified to you at the time of
          your request. In addition, as explained in
          Section 2.3, certain information may always be
          publicly available to others and other
          information is made publicly available to others
          by default.
        </li>
        <li>
          object to processing of your personal data. This
          enables you to object to the processing of your
          personal data if you feel it impacts on your
          fundamental rights and freedoms. For example,
          this can be where we are processing your
          personal data for direct marketing purposes. In
          some cases, we may have compelling legitimate
          grounds to process your information which can
          override your right to object.
        </li>
        <li>
          request restriction of processing of your
          personal data. This gives you the option to ask
          us to suspend the processing of your personal
          data in the following scenarios: i) if you want
          us to establish the data s accuracy; ii) where
          our use of the data is unlawful but you do not
          want us to erase it; iii) where you need us to
          hold the data, even if we no longer require it
          e.g. to establish or defend legal claims; or iv)
          you have objected to our use of your data but we
          need to verify whether we have overriding
          legitimate ground to use it.
        </li>
        <li>
          request transfer of your personal data. If you
          request us to do so, we will provide to you, or
          a third party of your choice, your personal data
          in a commonly used, machine-readable format.
          Note that this right only applies to automated
          information which you initially provided consent
          for us to use, or where we have used the
          information to perform a contract with you.
        </li>
        <li>
          withdraw consent to the processing of your data.
          If you request us to do so, we will no longer
          process your data. However, this will not affect
          the lawfulness of any processing carried out
          before you withdraw your consent. If you
          withdraw your consent, we may not be able to
          provide our Service for you. Also, we will
          advise you of this at the time you withdraw your
          consent.
        </li>
        <li>
          not have a decision made about you based solely
          on automated processing.
        </li>
      </ol>
      <p>
        If you wish to exercise any of the rights set out
        above or request details about the specific legal
        basis we are relying on to process your personal
        data, please email us at{' '}
        <a href="mailto:privacy@nakednews.com">
          privacy@nakednews.com
        </a>
      </p>
      <p>
        We will respond to you within 30 days of receipt of
        your request. Occasionally it may take us longer
        than 30 days if your request is particularly complex
        or you have made a number of requests. In this case,
        we will notify you and keep you updated.
      </p>
      <p>
        We may need to request specific information from you
        to help us confirm your identity and ensure your
        right to access your personal data (or to exercise
        your other legal rights). This is a security measure
        to ensure that your personal data is not disclosed
        to any person who does not have the right to receive
        it. We may also contact you to ask you for further
        information, in relation to your request, to speed
        up our response.
      </p>
      <p>
        You will not have to pay a fee to access your
        personal data (or to exercise any of your other
        legal rights). However, we may charge a reasonable
        fee if your request is clearly unfounded, repetitive
        or excessive. Alternatively, we may refuse to comply
        with your request in these circumstances.
      </p>
      <p>
        You have the right to make a complaint at any time
        to the Information Commissioner s Office (ICO), the
        UK supervisory authority for data protection issues
        (www.ico.org.uk). We would, however, appreciate the
        chance to deal with your concerns before you
        approach the ICO so please email us at{' '}
        <a href="mailto:privacy@nakednews.com">
          privacy@nakednews.com
        </a>{' '}
        in the first instance.
      </p>
      <a name="s15" />
      <p className="h4">15. Data retention</p>
      <p>
        If you are located in the European Union, or if the
        GDPR otherwise applies to your data as processed by
        us, we will only retain your personal data for as
        long as necessary to fulfil the purposes for which
        we collected it, including for the purposes of
        satisfying any legal, accounting, or internal
        reporting requirements. To determine the appropriate
        retention period for personal data, we consider the
        amount, nature, and sensitivity of the personal
        data, the potential risk of harm from unauthorized
        use or disclosure of your personal data, the
        purposes for which we process your personal data and
        whether we can achieve those purposes through other
        means, and the applicable legal requirements.
      </p>
      <p>
        In some circumstances we may anonymize your personal
        data (so that it can no longer be associated with
        you) for compliance, governance, legal and/or
        regulatory purposes in which case we may use this
        information indefinitely without further notice to
        you.
      </p>
      <a name="s16" />
      <p className="h4">
        16. Cooperation with law enforcement; fraud
        protection
      </p>
      <p>
        We fully cooperate with law enforcement agencies in
        identifying those who use our Website or Service for
        illegal activities. We reserve the right to disclose
        information about members who we believe are in
        violation of applicable laws or regulations, or as
        required to respond to a subpoena, court orders or
        other legal process requiring such disclosure. We
        also reserve the right to report to law enforcement
        agencies any activities that we reasonably believe
        to be unlawful and to exchange information with
        other companies and organizations for fraud
        protection.
      </p>
      <a name="s17" />
      <p className="h4">17. Changes to this Privacy Policy</p>
      <p>
        Occasionally we may, in our discretion, make changes
        to this Privacy Policy. When we make material
        changes to this Privacy Policy, we ll provide you
        with prominent notice as appropriate under the
        circumstances, e.g. by displaying a prominent notice
        within the Website or by sending you an email. In
        some cases, we will notify you in advance, and your
        continued use of the Website after the changes have
        been made will constitute your acceptance of the
        changes. Please therefore make sure you read any
        such notice carefully. If you object to any of the
        changes, you have the opportunity to delete your
        account and any associated information. Once deleted
        your details will be non-recoverable.
      </p>
      <p>
        Please note that if you opt out of receiving notices
        from us, change notices will still govern your use
        of the Website, and you are responsible for
        reviewing such legal notices for changes, as posted
        on the Website.
      </p>
      <a name="s18" />
      <p className="h4">18. Who we are</p>
      <p>
        For the purposes of the GDPR, Egalaxy Multimedia Inc, a corporation with its principal offices located 2133 Danforth Avenue, Suite 195, Toronto ON, M4C 1K2, Canada is the Data Controller and is responsible for your personal data. This means that we determine the purposes and ways of the processing of your personal data
      </p>
    </div>
  </div>
);

export default PrivacyPolicy;
